import {ReactComponent as Set1PromoIcon} from "../assets/iconStyles/set_1/set_1_Promo.svg";
import {ReactComponent as Set2PromoIcon} from "../assets/iconStyles/set_2/set_2_Promo-1.svg";
import {ReactComponent as Set3PromoIcon} from "../assets/iconStyles/set_3/set_3_Promo-2.svg";
import {ReactComponent as Set4PromoIcon} from "../assets/iconStyles/set_4/set_4_Promo-3.svg";
import {ReactComponent as Set5PromoIcon} from "../assets/iconStyles/set_5/set_5_Promo-4.svg";
import {ReactComponent as Set6PromoIcon} from "../assets/iconStyles/set_6/set_6_Promo-5.svg";
import {ReactComponent as Set7PromoIcon} from "../assets/iconStyles/set_7/set_7_Promo-6.svg";
import {ReactComponent as Set8PromoIcon} from "../assets/iconStyles/set_8/set_8_Promo-7.svg";
import {ReactComponent as Set1PageIcon} from "../assets/iconStyles/set_1/set_1_Page.svg";
import {ReactComponent as Set2PageIcon} from "../assets/iconStyles/set_2/set_2_Page-1.svg";
import {ReactComponent as Set3PageIcon} from "../assets/iconStyles/set_3/set_3_Page-2.svg";
import {ReactComponent as Set4PageIcon} from "../assets/iconStyles/set_4/set_4_Page-3.svg";
import {ReactComponent as Set5PageIcon} from "../assets/iconStyles/set_5/set_5_Page-4.svg";
import {ReactComponent as Set6PageIcon} from "../assets/iconStyles/set_6/set_6_Page-5.svg";
import {ReactComponent as Set7PageIcon} from "../assets/iconStyles/set_7/set_7_Page-6.svg";
import {ReactComponent as Set8PageIcon} from "../assets/iconStyles/set_8/set_8_Page-7.svg";
import {ReactComponent as Set1LinkIcon} from "../assets/iconStyles/set_1/set_1_Link.svg";
import {ReactComponent as Set2LinkIcon} from "../assets/iconStyles/set_2/set_2_Link-1.svg";
import {ReactComponent as Set3LinkIcon} from "../assets/iconStyles/set_3/set_3_Link-2.svg";
import {ReactComponent as Set4LinkIcon} from "../assets/iconStyles/set_4/set_4_Link-3.svg";
import {ReactComponent as Set5LinkIcon} from "../assets/iconStyles/set_5/set_5_Link-4.svg";
import {ReactComponent as Set6LinkIcon} from "../assets/iconStyles/set_6/set_6_Link-5.svg";
import {ReactComponent as Set7LinkIcon} from "../assets/iconStyles/set_7/set_7_Link-6.svg";
import {ReactComponent as Set8LinkIcon} from "../assets/iconStyles/set_8/set_8_Link-7.svg";
import {ReactComponent as Set1VideoIcon} from "../assets/iconStyles/set_1/set_1_Video.svg";
import {ReactComponent as Set2VideoIcon} from "../assets/iconStyles/set_2/set_2_Video-1.svg";
import {ReactComponent as Set3VideoIcon} from "../assets/iconStyles/set_3/set_3_Video-2.svg";
import {ReactComponent as Set4VideoIcon} from "../assets/iconStyles/set_4/set_4_Video-3.svg";
import {ReactComponent as Set5VideoIcon} from "../assets/iconStyles/set_5/set_5_Video-4.svg";
import {ReactComponent as Set6VideoIcon} from "../assets/iconStyles/set_6/set_6_Video-5.svg";
import {ReactComponent as Set7VideoIcon} from "../assets/iconStyles/set_7/set_7_Video-6.svg";
import {ReactComponent as Set8VideoIcon} from "../assets/iconStyles/set_8/set_8_Video-7.svg";
import {ReactComponent as Set1ImageIcon} from "../assets/iconStyles/set_1/set_1_Image.svg";
import {ReactComponent as Set2ImageIcon} from "../assets/iconStyles/set_2/set_2_Image-1.svg";
import {ReactComponent as Set3ImageIcon} from "../assets/iconStyles/set_3/set_3_Image-2.svg";
import {ReactComponent as Set4ImageIcon} from "../assets/iconStyles/set_4/set_4_Image-3.svg";
import {ReactComponent as Set5ImageIcon} from "../assets/iconStyles/set_5/set_5_Image-4.svg";
import {ReactComponent as Set6ImageIcon} from "../assets/iconStyles/set_6/set_6_Image-5.svg";
import {ReactComponent as Set7ImageIcon} from "../assets/iconStyles/set_7/set_7_Image-6.svg";
import {ReactComponent as Set8ImageIcon} from "../assets/iconStyles/set_8/set_8_Image-7.svg";
import {ReactComponent as Set1360Icon} from "../assets/iconStyles/set_1/set_1_360.svg";
import {ReactComponent as Set2360Icon} from "../assets/iconStyles/set_2/set_2_360-1.svg";
import {ReactComponent as Set3360Icon} from "../assets/iconStyles/set_3/set_3_360-2.svg";
import {ReactComponent as Set4360Icon} from "../assets/iconStyles/set_4/set_4_360-3.svg";
import {ReactComponent as Set5360Icon} from "../assets/iconStyles/set_5/set_5_360-4.svg";
import {ReactComponent as Set6360Icon} from "../assets/iconStyles/set_6/set_6_360-5.svg";
import {ReactComponent as Set7360Icon} from "../assets/iconStyles/set_7/set_7_360-6.svg";
import {ReactComponent as Set8360Icon} from "../assets/iconStyles/set_8/set_8_360-7.svg";
import set1PromoIcon from "../assets/iconStyles/set_1/set_1_Promo.svg";
import set2PromoIcon from "../assets/iconStyles/set_2/set_2_Promo-1.svg";
import set3PromoIcon from "../assets/iconStyles/set_3/set_3_Promo-2.svg";
import set4PromoIcon from "../assets/iconStyles/set_4/set_4_Promo-3.svg";
import set5PromoIcon from "../assets/iconStyles/set_5/set_5_Promo-4.svg";
import set6PromoIcon from "../assets/iconStyles/set_6/set_6_Promo-5.svg";
import set7PromoIcon from "../assets/iconStyles/set_7/set_7_Promo-6.svg";
import set8PromoIcon from "../assets/iconStyles/set_8/set_8_Promo-7.svg";
import set1PageIcon from "../assets/iconStyles/set_1/set_1_Page.svg";
import set2PageIcon from "../assets/iconStyles/set_2/set_2_Page-1.svg";
import set3PageIcon from "../assets/iconStyles/set_3/set_3_Page-2.svg";
import set4PageIcon from "../assets/iconStyles/set_4/set_4_Page-3.svg";
import set5PageIcon from "../assets/iconStyles/set_5/set_5_Page-4.svg";
import set6PageIcon from "../assets/iconStyles/set_6/set_6_Page-5.svg";
import set7PageIcon from "../assets/iconStyles/set_7/set_7_Page-6.svg";
import set8PageIcon from "../assets/iconStyles/set_8/set_8_Page-7.svg";
import set1LinkIcon from "../assets/iconStyles/set_1/set_1_Link.svg";
import set2LinkIcon from "../assets/iconStyles/set_2/set_2_Link-1.svg";
import set3LinkIcon from "../assets/iconStyles/set_3/set_3_Link-2.svg";
import set4LinkIcon from "../assets/iconStyles/set_4/set_4_Link-3.svg";
import set5LinkIcon from "../assets/iconStyles/set_5/set_5_Link-4.svg";
import set6LinkIcon from "../assets/iconStyles/set_6/set_6_Link-5.svg";
import set7LinkIcon from "../assets/iconStyles/set_7/set_7_Link-6.svg";
import set8LinkIcon from "../assets/iconStyles/set_8/set_8_Link-7.svg";
import set1VideoIcon from "../assets/iconStyles/set_1/set_1_Video.svg";
import set2VideoIcon from "../assets/iconStyles/set_2/set_2_Video-1.svg";
import set3VideoIcon from "../assets/iconStyles/set_3/set_3_Video-2.svg";
import set4VideoIcon from "../assets/iconStyles/set_4/set_4_Video-3.svg";
import set5VideoIcon from "../assets/iconStyles/set_5/set_5_Video-4.svg";
import set6VideoIcon from "../assets/iconStyles/set_6/set_6_Video-5.svg";
import set7VideoIcon from "../assets/iconStyles/set_7/set_7_Video-6.svg";
import set8VideoIcon from "../assets/iconStyles/set_8/set_8_Video-7.svg";
import set1ImageIcon from "../assets/iconStyles/set_1/set_1_Image.svg";
import set2ImageIcon from "../assets/iconStyles/set_2/set_2_Image-1.svg";
import set3ImageIcon from "../assets/iconStyles/set_3/set_3_Image-2.svg";
import set4ImageIcon from "../assets/iconStyles/set_4/set_4_Image-3.svg";
import set5ImageIcon from "../assets/iconStyles/set_5/set_5_Image-4.svg";
import set6ImageIcon from "../assets/iconStyles/set_6/set_6_Image-5.svg";
import set7ImageIcon from "../assets/iconStyles/set_7/set_7_Image-6.svg";
import set8ImageIcon from "../assets/iconStyles/set_8/set_8_Image-7.svg";
import set1360Icon from "../assets/iconStyles/set_1/set_1_360.svg";
import set2360Icon from "../assets/iconStyles/set_2/set_2_360-1.svg";
import set3360Icon from "../assets/iconStyles/set_3/set_3_360-2.svg";
import set4360Icon from "../assets/iconStyles/set_4/set_4_360-3.svg";
import set5360Icon from "../assets/iconStyles/set_5/set_5_360-4.svg";
import set6360Icon from "../assets/iconStyles/set_6/set_6_360-5.svg";
import set7360Icon from "../assets/iconStyles/set_7/set_7_360-6.svg";
import set8360Icon from "../assets/iconStyles/set_8/set_8_360-7.svg";
import {IconStyleDto} from "../dtos";

export const iconStyles: IconStyleDto[] = [
    {
        value: "1",
        label: "Black cart on White circle",
        iconStyleType: 1,
        iconStyleData: {
            promoCompIcon: Set1PromoIcon,
            pageCompIcon: Set1PageIcon,
            linkCompIcon: Set1LinkIcon,
            videoCompIcon: Set1VideoIcon,
            imgCompIcon: Set1ImageIcon,
            img360CompIcon: Set1360Icon,
            promoCompSrc: set1PromoIcon,
            pageCompSrc: set1PageIcon,
            linkCompSrc: set1LinkIcon,
            videoCompSrc: set1VideoIcon,
            imgCompSrc: set1ImageIcon,
            img360CompSrc: set1360Icon,
        }
    },
    {
        value: "2",
        label: "Black cart on main color",
        iconStyleType: 2,
        iconStyleData: {
            promoCompIcon: Set2PromoIcon,
            pageCompIcon: Set2PageIcon,
            linkCompIcon: Set2LinkIcon,
            videoCompIcon: Set2VideoIcon,
            imgCompIcon: Set2ImageIcon,
            img360CompIcon: Set2360Icon,
            promoCompSrc: set2PromoIcon,
            pageCompSrc: set2PageIcon,
            linkCompSrc: set2LinkIcon,
            videoCompSrc: set2VideoIcon,
            imgCompSrc: set2ImageIcon,
            img360CompSrc: set2360Icon,
        }
    },
    {
        value: "3",
        label: "White cart on main color",
        iconStyleType: 3,
        iconStyleData: {
            promoCompIcon: Set3PromoIcon,
            pageCompIcon: Set3PageIcon,
            linkCompIcon: Set3LinkIcon,
            videoCompIcon: Set3VideoIcon,
            imgCompIcon: Set3ImageIcon,
            img360CompIcon: Set3360Icon,
            promoCompSrc: set3PromoIcon,
            pageCompSrc: set3PageIcon,
            linkCompSrc: set3LinkIcon,
            videoCompSrc: set3VideoIcon,
            imgCompSrc: set3ImageIcon,
            img360CompSrc: set3360Icon,
        }
    },
    {
        value: "4",
        label: "White cart on red color",
        iconStyleType: 4,
        iconStyleData: {
            promoCompIcon: Set4PromoIcon,
            pageCompIcon: Set4PageIcon,
            linkCompIcon: Set4LinkIcon,
            videoCompIcon: Set4VideoIcon,
            imgCompIcon: Set4ImageIcon,
            img360CompIcon: Set4360Icon,
            promoCompSrc: set4PromoIcon,
            pageCompSrc: set4PageIcon,
            linkCompSrc: set4LinkIcon,
            videoCompSrc: set4VideoIcon,
            imgCompSrc: set4ImageIcon,
            img360CompSrc: set4360Icon,
        }
    },
    {
        value: "5",
        label: "White cart on green color",
        iconStyleType: 5,
        iconStyleData: {
            promoCompIcon: Set5PromoIcon,
            pageCompIcon: Set5PageIcon,
            linkCompIcon: Set5LinkIcon,
            videoCompIcon: Set5VideoIcon,
            imgCompIcon: Set5ImageIcon,
            img360CompIcon: Set5360Icon,
            promoCompSrc: set5PromoIcon,
            pageCompSrc: set5PageIcon,
            linkCompSrc: set5LinkIcon,
            videoCompSrc: set5VideoIcon,
            imgCompSrc: set5ImageIcon,
            img360CompSrc: set5360Icon,
        }
    },
    {
        value: "6",
        label: "White cart on blue color",
        iconStyleType: 6,
        iconStyleData: {
            promoCompIcon: Set6PromoIcon,
            pageCompIcon: Set6PageIcon,
            linkCompIcon: Set6LinkIcon,
            videoCompIcon: Set6VideoIcon,
            imgCompIcon: Set6ImageIcon,
            img360CompIcon: Set6360Icon,
            promoCompSrc: set6PromoIcon,
            pageCompSrc: set6PageIcon,
            linkCompSrc: set6LinkIcon,
            videoCompSrc: set6VideoIcon,
            imgCompSrc: set6ImageIcon,
            img360CompSrc: set6360Icon,
        }
    },
    {
        value: "7",
        label: "White cart on beige color",
        iconStyleType: 7,
        iconStyleData: {
            promoCompIcon: Set7PromoIcon,
            pageCompIcon: Set7PageIcon,
            linkCompIcon: Set7LinkIcon,
            videoCompIcon: Set7VideoIcon,
            imgCompIcon: Set7ImageIcon,
            img360CompIcon: Set7360Icon,
            promoCompSrc: set7PromoIcon,
            pageCompSrc: set7PageIcon,
            linkCompSrc: set7LinkIcon,
            videoCompSrc: set7VideoIcon,
            imgCompSrc: set7ImageIcon,
            img360CompSrc: set7360Icon,
        }
    },
    {
        value: "8",
        label: "Black cart on light grey color",
        iconStyleType: 8,
        iconStyleData: {
            promoCompIcon: Set8PromoIcon,
            pageCompIcon: Set8PageIcon,
            linkCompIcon: Set8LinkIcon,
            videoCompIcon: Set8VideoIcon,
            imgCompIcon: Set8ImageIcon,
            img360CompIcon: Set8360Icon,
            promoCompSrc: set8PromoIcon,
            pageCompSrc: set8PageIcon,
            linkCompSrc: set8LinkIcon,
            videoCompSrc: set8VideoIcon,
            imgCompSrc: set8ImageIcon,
            img360CompSrc: set8360Icon,
        }
    },
]
